import { Injectable } from '@angular/core';
import { SelectableRow } from '@os-components';
import { SparePart } from '../../../features/result/spare-parts-result/spare-parts.interface';
import { BasketItem } from '../../../services/basket.service';
import { DialogComponent, WizardStep } from './part-configuration-wizard.component';

export interface BasketItemRow {
    basketItem: BasketItem;
    // row only needed for gear oil cross selling tables
    row?: SelectableRow<SparePart>;
}
export interface StoreStepItems {
    // mapping spare part from search result table to new configured basket items
    [sparePartId: string]: BasketItemRow[];
}

export interface ConfiguredBasketItemStep {
    // the step identifies the current step of the wizard
    step: WizardStep<DialogComponent>;
    // all configured items for the step. In case of gear oil we have one item per table (selected gear oil item in search result table).
    // one gear oil item, can contain multiple basket items (max. number of rows in gear oil cross selling table)
    items: StoreStepItems;
}

@Injectable({
    providedIn: 'root',
})
export class PartConfigurationWizardService {
    private store: ConfiguredBasketItemStep[] = [];

    public addStepItems(step: ConfiguredBasketItemStep) {
        const index = this.store.findIndex((storeStep) => storeStep.step.component === step.step.component);

        if (index !== -1) {
            this.store[index] = step;
        } else {
            this.store = [...this.store, step];
        }
    }

    public get storeditems() {
        return this.store;
    }

    public clearStorage() {
        this.store = [];
    }
}
